import React from "react";
import { NavLink } from "react-router-dom";
import { FolderTree, Files, Upload } from "lucide-react";
import { cn } from "../lib/utils";

const linkClass = ({ isActive }) =>
  cn(
    "inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition-colors",
    isActive
      ? "bg-slate-900 text-white"
      : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
  );

export function AdminNav() {
  return (
    <nav
      className="inline-flex gap-1 rounded-xl border border-slate-200 bg-white p-1 mb-6"
      data-testid="admin-nav"
    >
      <NavLink to="/admin" end className={linkClass} data-testid="admin-nav-pdfs">
        <Files className="h-4 w-4" />
        PDFs
      </NavLink>
      <NavLink to="/admin/categories" className={linkClass} data-testid="admin-nav-categories">
        <FolderTree className="h-4 w-4" />
        Categories
      </NavLink>
      <NavLink to="/admin/import" className={linkClass} data-testid="admin-nav-import">
        <Upload className="h-4 w-4" />
        Import
      </NavLink>
    </nav>
  );
}
